<script>
import { formatNumber } from '@ubic/utils/formatters';
import IconGhost from '@/components/icons/Ghost';

export default {
  props: {
    totalHours: {
      type: Number,
      required: true,
    },
    projects: {
      type: Array,
      required: true,
    },
    mapColors: {
      type: Object,
      required: true,
    },
  },
  computed: {
    maxHours () {
      return Math.max(...this.projects.map(project => project.totalHours));
    },
  },
  render () {
    if (this.isFetching) {
      return <u-spinner />;
    }

    const { $style, projects, maxHours, totalHours, mapColors } = this;

    return (
      <div>
        {!projects.length && (
          <div class={$style.empty}>
            <span class={$style.emptyIcon}>
              <IconGhost />
            </span>
            <span>
              Ничего не найдено
            </span>
          </div>
        )}

        {projects.length > 0 && (
          <div class={$style.project}>
            <div class={$style.projectInfo}>
              <span class={$style.projectName}>
                Всего за период
              </span>
              <span class={$style.projectHours}>
                {formatNumber(totalHours, { round: 2 })}
                ч
              </span>
            </div>
          </div>
        )}

        {projects.map(project => (
          <div
            key={project.id}
            class={$style.project}
          >
            <div class={$style.projectInfo}>
              <span
                class={$style.projectDepartmentColor}
                style={{ color: mapColors[project.id] }}
              />
              <span class={$style.projectName}>
                {project.name}
              </span>
              <span class={$style.projectHours}>
                {formatNumber(project.totalHours, { round: 2 })}
                ч
              </span>
              <span class={$style.projectPercentage}>
                {formatNumber(
                  100 * (project.totalHours / totalHours),
                  { round: 2 },
                )}
                %
              </span>
            </div>
            <div
              class={$style.projectPayload}
              style={{ width: `${100 * (project.totalHours / maxHours)}%` }}
            />
          </div>
        ))}
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.empty {
  align-items: center;
  color: $color-gray;
  display: flex;

  &Icon {
    color: $color-gray-lighter;
    font-size: 4em;
    margin-right: .5em;
  }
}

.project {
  & + & {
    margin-top: 1em;
  }

  &Info {
    align-items: center;
    display: flex;
    margin-bottom: .25em;
  }

  &DepartmentColor {
    background-color: currentColor;
    border-radius: 50%;
    display: inline-block;
    font-size: .75rem;
    height: 1em;
    margin-right: .5em;
    width: 1em;
  }

  &Name {
    width: 160px;
  }

  &Hours {
    font-weight: bold;
    text-align: right;
    width: 80px;
  }

  &Percentage {
    font-size: .825em;
    text-align: right;
    width: 60px;
  }

  &Payload {
    background-color: $color-gray;
    border-radius: .25em;
    height: .5em;
  }
}
</style>
